import { render, staticRenderFns } from "./huiben.vue?vue&type=template&id=20d156f7&scoped=true"
import script from "./huiben.vue?vue&type=script&lang=js"
export * from "./huiben.vue?vue&type=script&lang=js"
import style0 from "./huiben.vue?vue&type=style&index=0&id=20d156f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d156f7",
  null
  
)

export default component.exports